var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowtoVender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3668 -10824)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3668.373 10824)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(-0.373)",
    fill: "#b7e7f3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3673.831 10829.428)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.228,290.389a.389.389,0,0,0-.389-.389h-2.45a.389.389,0,0,0-.389.389v2.295a.389.389,0,0,0,.389.389h2.45a.389.389,0,0,0,.389-.389Zm-2.45.389H68.45v1.517H66.778Z",
    transform: "translate(-63.436 -278.721)",
    fill: "#76747f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.228,290.389a.389.389,0,0,0-.389-.389h-2.45a.389.389,0,0,0-.389.389v2.295a.389.389,0,0,0,.389.389h2.45a.389.389,0,0,0,.389-.389Zm-2.45.389h1.672v1.517h-1.672Z",
    transform: "translate(-305.635 -278.721)",
    fill: "#76747f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.268,5.873v-.01a.364.364,0,0,0-.008-.039.045.045,0,0,0,0-.007.384.384,0,0,0-.039-.091h0L16.543,2.878a1.18,1.18,0,0,0-1-.583h-1.51V.408a.418.418,0,0,0-.4-.408H4.71a.418.418,0,0,0-.4.408V2.295h-1.2a1.176,1.176,0,0,0-.957.508L.136,5.692c-.005.007-.01.017-.014.025l0,.007-.011.021,0,.008-.01.022v0a.37.37,0,0,0-.013.042l0,.014a.1.1,0,0,1,0,.017.087.087,0,0,1,0,.019c0,.007,0,.009,0,.014a.311.311,0,0,0,0,.033h0V7.552a1.159,1.159,0,0,0,1.157,1.16H1.35v8.849a.4.4,0,0,0,.379.408H16.586a.414.414,0,0,0,.4-.408V8.712H17.1a1.159,1.159,0,0,0,1.164-1.154V5.92A.384.384,0,0,0,18.268,5.873ZM5.083.778h8.168V2.64c0,.02-.005.041-.005.062s.005.042.005.062V4.123H5.083ZM2.789,3.244a.394.394,0,0,1,.317-.172h1.2V4.531a.385.385,0,0,0,.4.37h8.919a.386.386,0,0,0,.4-.37V3.073h1.508a.4.4,0,0,1,.335.194L17.2,5.523H1.2Zm8.168,13.947H7.378V11.9h3.578Zm5.251,0H11.734V11.5a.388.388,0,0,0-.4-.373H6.983a.369.369,0,0,0-.381.357v5.711H2.128V8.712H16.207Zm.9-9.257H1.233A.381.381,0,0,1,.844,7.56V6.3H17.49V7.553a.381.381,0,0,1-.38.381Z",
    transform: "translate(-0.069)",
    fill: "#76747f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowtoVender);
export default __webpack_public_path__ + "static/media/ShowtoVender.0dcb0be585f713e0ec2cee5449221bb9.svg";
export { ForwardRef as ReactComponent };